var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 63",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:none;stroke:currentColor;stroke-width:3;stroke-miterlimit:10;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m16.254 12.72c-10.267 8.421-11.791 23.724-3.3688 34.17 6.0158 7.4493 15.802 10.607 25.026 8.0161",
    strokeWidth: 2.4864
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m46.734 50.29c10.267-8.5019 11.711-23.805 3.2886-34.17-6.0158-7.3683-15.721-10.526-24.865-8.0161",
    opacity: 0.99,
    strokeWidth: 2.4864
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    transform: "matrix(.80211 0 0 .80971 6.2277 5.9993)",
    points: "58.8 54.7 49.9 54.9 50.6 45.5",
    strokeWidth: 3.0852
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    transform: "matrix(.80211 0 0 .80971 6.2277 5.9993)",
    points: "3.5 9 12.8 7.2 13.3 16.4",
    strokeWidth: 3.0852
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m24.756 31.181c0 4.1295 3.2886 7.4493 7.3794 7.4493s7.3794-3.3198 7.3794-7.4493c0-4.1295-3.2886-7.4493-7.3794-7.4493s-7.3794 3.3198-7.3794 7.4493z",
    strokeWidth: 2.4864
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.168 31.181c0 1.7004 1.3636 3.0769 3.048 3.0769s3.048-1.3765 3.048-3.0769-1.3636-3.0769-3.048-3.0769c-1.6844-0.08097-3.048 1.2955-3.048 3.0769z",
    fill: "currentColor",
    strokeWidth: 2.4864
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperation);
export default __webpack_public_path__ + "static/media/operation.66850598a29135fe3cd0563873e37e05.svg";
export { ForwardRef as ReactComponent };